import React from 'react';
import Header from './Header';
import Container from '../UI/Container';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with Navigation */}
      <Header />

      {/* Main Content */}
      <main className="py-6">
        <Container>
          {children}
        </Container>
      </main>
    </div>
  );
};

export default Layout; 